import sweetAlert from 'sweetalert';
import {event, localize, message} from 'linksoft';
import debug from 'debug';
const Resx = localize('Common');
const log = debug('linksoft:sweetalert');

const config = {
	'default': {},
	info: {
		type: 'info'
	},
	success: {
		type: 'success'
	},
	warn: {
		type: 'warning'
	},
	error: {
		type: 'error'
	},
	confirm: {
		type: 'warning',
		title: 'Are you sure?',
		showCancelButton: true,
		cancelButtonText: 'Cancel',
		confirmButtonColor: "#DD6B55",
		confirmButtonText: 'Yes'
	}
};


function showMessage(type, message, title, options) {
	if (!title) {
		title = message;
		message = undefined;
	}

	const opts = {
		...config.default,
		...config[type],
		...options,
		title: title,
		text: message
	};

	return new Promise(function (resolve) {
		if(!opts.title) {
			log('title is missing: %o', opts);
			return resolve();
		}
		sweetAlert(opts, function () {
			resolve();
		});
	});
}

function confirm(message, title, callback, options) {
	const userOpts = {
		text: message
	};

	if(title) {
	    userOpts.title = title;
    }

	const opts = {
		...config.default,
		...config.confirm,
		...userOpts,
        ...options
	};


	return new Promise(function (resolve, reject) {
		if(!opts.title) {
			log('title is missing: %o', opts);
			return reject();
		}
		sweetAlert(opts, function (isConfirmed) {
			callback && callback(isConfirmed);
			isConfirmed ? resolve() : reject();
		});
	});
}


event.on('linksoft.localeLoaded', function(){
	config.confirm.confirmButtonText = Resx.Common.Confirm;
	config.confirm.cancelButtonText = Resx.Common.Cancel;
});

message.implementation({
   showMessage,
   confirm
});

export default config;


// WEBPACK FOOTER //
// ./node_modules/linksoft-sweetalert/src/index.js